<body class="ltr  leftmenu">
    <form autocomplete="off" novalidate [formGroup]="complaintForm">
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="receipt ">
                                        <div class="row ">
                                            <div class="col-sm-12">
                                                <img src="../../assets/images/logo-light.png"
                                                    class="header-brand-img reciptLogo desktop-logo" alt="logo">
                                                <h4 class="mra">{{InstuName}}</h4>
                                                <h5 class="mra1">Student Complaint Form</h5>
                                            </div>
                                        </div>
                                        <div class="scroll" style="max-height: 400px; overflow-y: auto;">
                                            <div class="row">
                                                <div class="receipt-details">
                                                    <div class="row">
                                                        <div class="col-sm-12 ">
                                                            <p><b>Student Name: </b>{{grivenceData.StuFirstName}}
                                                                {{grivenceData.StuMidName}} {{grivenceData.StuLastName}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <p><b>Address: </b>{{grivenceData.StuAddrC}}</p>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <p><b>City/State/Zip:
                                                                </b>{{grivenceData.StuCityC}}/{{grivenceData.StateName}}/{{grivenceData.StuPinC}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <!-- <div class="col-sm-6">
                                                            <p><b>Reg No.: </b>{{grivenceData.LoginId}}</p>
                                                        </div> -->
                                                        <div class="col-sm-6" *ngIf="PreFix != ''">
                                                            <p><b>Rg No.:</b>{{PreFix}}/{{formattedPrn}}</p>
                                                        </div>
                                                        <div class="col-sm-6" *ngIf="PreFix == '' ">
                                                            <p><b>Rg No.:</b>{{formattedPrn}}</p>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <p><b>Session: </b>{{session}}</p>
                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <p><b>Mobile Phone Number: </b>{{grivenceData.StuMobNumber}}
                                                            </p>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <p><b>Course: </b>{{grivenceData.CoName}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="receipt-details">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> Department </mat-label>
                                                                <mat-select #select583 class="colorblack"
                                                                    formControlName="DepartmentID" disabled
                                                                    (selectionChange)="onDepartmentChange($event.value)">
                                                                    <mat-select-filter *ngIf="select583.focused"
                                                                        [placeholder]="'Filter'"
                                                                        [displayMember]="'DepartmentName'"
                                                                        [array]="departmentList"
                                                                        (filteredReturn)="filterdepartmentList =$event"></mat-select-filter>
                                                                    <mat-option
                                                                        *ngFor="let item of filterdepartmentList"
                                                                        [value]="item.DepartmentID">
                                                                        {{item.DepartmentName}}
                                                                    </mat-option>
                                                                </mat-select>

                                                            </mat-form-field>
                                                        </div>
                                                        <div *ngIf="showOtherTextArea" class="col-sm-4">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>Specify Other Department</mat-label>
                                                                <textarea matInput></textarea>
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="receipt-details">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>Grievance Title</mat-label>
                                                                <input matInput formControlName="GrievanceTitle"
                                                                    readonly>
                                                            </mat-form-field>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> Grievance Status </mat-label>
                                                                <mat-select #select593 class="colorblack"
                                                                    formControlName="StatusCode" disabled>
                                                                    <mat-select-filter *ngIf="select593.focused"
                                                                        [placeholder]="'Filter'"
                                                                        [displayMember]="'CdCode'" [array]="statusList"
                                                                        (filteredReturn)="filterstatusList =$event"></mat-select-filter>
                                                                    <mat-option *ngFor="let item of filterstatusList"
                                                                        [value]="item.CdCode">
                                                                        {{item.CdDesc}}
                                                                    </mat-option>
                                                                </mat-select>

                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="receipt-details">
                                                    <div class="row">
                                                        <div class="col-sm-12 mt-2 mb-2">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>Describe your concern/complaint in
                                                                    detail</mat-label>
                                                                <textarea matInput
                                                                    formControlName="GrievanceDescription" rows="4"
                                                                    maxlength="500" readonly
                                                                    placeholder="Describe your concern/complaint in detail.Include date/s of occurrence."
                                                                    class="form-control"></textarea>
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="receipt-details">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <p><b>Have you made an attempt to resolve this
                                                                    concern/complaint with the individual
                                                                    and/or department involved?</b></p>
                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <mat-radio-group formControlName="PreviousAttempt" class="example-full-width">
                                                            <div class="col-sm-6">
                                                                <mat-radio-button [value]="true" disabled
                                                                    (change)="onOptionChange($event)">Yes</mat-radio-button>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <mat-radio-button [value]="false" disabled
                                                                    (change)="onOptionChange($event)">No</mat-radio-button>
                                                            </div>
                                                        </mat-radio-group>
                                                        <mat-form-field
                                                        *ngIf="complaintForm.get('PreviousAttempt')?.value === true"
                                                        appearance="outline" class="example-full-width">
                                                        <mat-label>Previous Attempt Details</mat-label>
                                                        <textarea matInput
                                                            formControlName="PreviousAttemptDetail" rows="4"
                                                            maxlength="500" placeholder="Enter details here"
                                                            class="form-control" readonly></textarea>
                                                    </mat-form-field>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>


                                        <div class="col-md-2 prpl offset-sm-10 mt-2">
                                            <button id="addBtn" type="button" class="btn btn-primary btn-icon-text "
                                                (click)="addnewrecord()">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/plus.gif"
                                                        style="margin-right: 5px;">
                                                    Add New
                                                </span>
                                            </button>
                                        </div>

                                        <div class="table-responsive table-container mt-2">
                                            <table appShortTable id="datatable"
                                                class="table table-bordered text-nowrap text-left">
                                                <thead>
                                                    <tr>
                                                        <th class="f600" text-center>
                                                            Sr No.
                                                        </th>
                                                        <th class="f600" text-center>
                                                            User
                                                        </th>
                                                        <th class="f600">
                                                            Status
                                                        </th>
                                                        <th class="f600">
                                                            Action/Comment
                                                        </th>
                                                        <th class="f600">
                                                            Date
                                                        </th>
                                                        <th class="f600" *ngIf="actionFormArray['Publish'][0]['FormRequired']">
                                                            
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody id="table_data">
                                                    <tr *ngFor="let actionComment of actionCommentList; let i = index;">
                                                        <td>
                                                            {{ i + 1 }}
                                                        </td>
                                                        <td>
                                                            {{actionComment.LoginFullName}}
                                                        </td>
                                                        <td>
                                                            <span *ngIf="actionComment.RecType === 'Action'">{{ actionComment.StatusDesc }}</span>
                                                            <span *ngIf="actionComment.RecType === 'Comment'">-</span>
                                                        </td>
                                                        <td>
                                                            <a *ngIf="actionComment.RecType == 'Action' "
                                                            class="floating mr-2 pr-3" title="Action">
                                                            <span class="font">A</span>
                                                        </a> <a *ngIf="actionComment.RecType == 'Comment' "
                                                            class=" ml-2 floating" title="Comment">
                                                            <span class="font">C</span> 
                                                        </a> 
                                                            {{actionComment.Action_Comment_Text}}
                                                        </td>
                                                        <td>
                                                            <!-- {{actionComment.DataTimestamp}} -->  
                                                            {{convertUTCToIST(actionComment.DataTimestamp)}}
                                                        </td>
                                                        <td class="text-center" *ngIf="actionFormArray['Publish'][0]['FormRequiredZZX']"> <a *ngIf="actionComment.IsPublish == true "
                                                            class="floating mr-2 pr-3" title="Public">
                                                            <i class="fa fa-users"></i>
                                                        </a> <a *ngIf="actionComment.IsPublish == false "
                                                            class=" ml-2 floating" title="Private"> <i
                                                                class="fa fa-user"></i> </a> </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <!-- *ngIf="showUpdateButton" -->
                                    <!-- [disabled]="grievancestatus" -->
                                    <!-- <button  type="button" class="btn btn-primary btn-icon-text floatright fr sz mt-2 mb-2"
                                        (click)="UpdateComplaint()" [disabled]="grievancestatus">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/img/edit1.gif"
                                                style="margin-right: 5px;">
                                            Update
                                        </span>
                                    </button> -->
                                    <button id="Back" type="button"
                                        class="btn btn-primary btn-icon-text floatright mt-2 mb-2" (click)="Back()">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/img/turn-left.gif"
                                                style="margin-right: 7px;">
                                            Back
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>